const type = {
  BASIC: 'BASICA',
  MICRO_DEPOSIT: 'MICRO_DEPOSITO'
};

module.exports = type;
